module.exports = __webpack_public_path__ + "static/media/qr-amazon.f896f173.svg";